// assets
import {
  Story,
  BoxAdd,
  Box1,
  DollarSquare,
  BoxTime,
  Calculator,
  Candle,
  Graph,
  Bank,
  Activity,
  Task,
  Calendar,
  Shop,
  Note
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  widgets: Story,
  list: Box1,
  prices: DollarSquare,
  create: BoxAdd,
  live: BoxTime,
  calculator: Calculator,
  historicData: Candle,
  brokers: Bank,
  recommendationTrades: Activity,
  recommendationList: Task,
  day: Calendar,
  orders: Shop,
  adminLogs: Note,
  optionChain: Graph
};

// ==============================|| MENU ITEMS - SIMULATION ||============================== //
// TODO: fix translation error=> remove other languages
const simulations: NavItemType = {
  id: 'group-simulation',
  title: 'Live Trades',
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'live-simulations',
      title: 'Live Trade',
      type: 'item',
      url: '/live-simulations',
      breadcrumbs: true,
      icon: icons.live
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item',
      url: '/orders',
      icon: icons.orders
    },
    {
      id: 'market-holidays',
      title: 'Market Holidays',
      type: 'item',
      url: '/market-holidays',
      breadcrumbs: true,
      icon: icons.day
    },
    {
      id: 'decision-logs',
      title: 'Decision Logs',
      type: 'item',
      url: '/decision-logs',
      breadcrumbs: true, // ✅ added
      icon: icons.adminLogs // ✅ added
    },
    {
      id: 'nifty-option-chain',
      title: 'NIFTY Option Chain',
      type: 'item',
      url: '/nifty-option-chain',
      breadcrumbs: true,
      icon: icons.optionChain
    },
    {
      id: 'sensex-option-chain',
      title: 'SENSEX Option Chain',
      type: 'item',
      url: '/sensex-option-chain',
      breadcrumbs: true,
      icon: icons.optionChain
    }
  ]
};

export default simulations;
